import { PageShell } from "@/components/marketing/PageShell";

const SECTIONS = [
  {
    h: "§ 101 — Permissible purpose",
    p: "Every case must declare a permitted purpose before submission. A Super Admin controls which purposes each client organization may use, and a case cannot proceed without one.",
  },
  {
    h: "§ 102 — Consent-first verification",
    p: "No work begins until the subject signs electronic consent. Consent text, signature, timestamp, and IP are stored immutably, and the declared address and roster lock as a read-only snapshot.",
  },
  {
    h: "§ 103 — Chain of custody",
    p: "Every signal and field visit is logged with source, result, and retrieval time. Reports store the exact evidence snapshot used, so findings are reproducible under audit.",
  },
  {
    h: "§ 104 — Consumer disputes",
    p: "Subjects may dispute any report by ID with an identity check. Each dispute receives a number, a reinvestigation deadline (default 30 days), and a written outcome sent to subject and client.",
  },
  {
    h: "§ 105 — Adverse action support",
    p: "When a client indicates a decision relied on a report, the system generates an adverse-action notice template including our contact details and the subject's right to dispute.",
  },
  {
    h: "§ 106 — Data minimization & certified purge",
    p: "Each case type collects only required fields. Data is purged on a configurable schedule per client policy, and each purge produces a downloadable purge certificate.",
  },
];

export default function ComplianceFramework() {
  return (
    <PageShell eyebrow="— COMPLIANCE FRAMEWORK —" title="How ResidenceProof is built to withstand audits">
      <p className="mb-8 max-w-2xl text-oath-secondary">
        The items below describe our intended operating controls. Regulatory badges such
        as FCRA-aligned practices and SOC 2 Type II are shown only after legal review and
        completed audits — all figures and certifications on this site are illustrative placeholders.
      </p>
      <div className="space-y-4">
        {SECTIONS.map((s) => (
          <div key={s.h} className="rounded-2xl border border-gray-200 bg-white p-6" data-testid={`framework-${s.h.match(/\d+/)[0]}`}>
            <h3 className="font-display text-lg font-bold text-oath-ink">
              <span className="text-oath-accent">{s.h.split(" ")[0]} </span>
              {s.h.replace(/^§ \d+ — /, "")}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-oath-secondary">{s.p}</p>
          </div>
        ))}
      </div>
    </PageShell>
  );
}
